var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 23C17.8513 23 23 17.8513 23 11.5C23 5.14873 17.8513 0 11.5 0C5.14873 0 0 5.14873 0 11.5C0 17.8513 5.14873 23 11.5 23Z",
    fill: "#039BE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.26234 11.2509L16.3503 6.97578C16.8649 6.78987 17.3143 7.10133 17.1476 7.87949L17.1486 7.87854L15.2606 16.7728C15.1207 17.4034 14.746 17.5567 14.2218 17.2597L11.3468 15.1408L9.96009 16.4767C9.80676 16.63 9.67738 16.7594 9.3803 16.7594L9.58442 13.8336L14.9128 9.01991C15.1447 8.81579 14.861 8.70079 14.5553 8.90395L7.97059 13.0497L5.132 12.1642C4.5158 11.9687 4.50238 11.548 5.26234 11.2509Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.109da67063ed64c25c4cc2f3e918bb1e.svg";
export { ForwardRef as ReactComponent };